import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Card } from 'primereact/card';
import { useParams } from 'react-router-dom';
import ShipmentDetail from '@components/obsolete/shipment/ShipmentDetail.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const ShipmentDetailPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  const { shipmentId } = useParams();

  return (
    <>
      <ResponsiveLayout title={tr(`ShipmentDetailPage.title`, `Shipment detail`)}>
        {/*
        // @ts-ignore*/}
        <Card>
          <ShipmentDetail shipmentId={shipmentId} />
        </Card>
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(ShipmentDetailPage);
